import {
  MuiThemeProvider,
  CssBaseline,
  responsiveFontSizes,
} from "@material-ui/core";
import { createTheme } from "@material-ui/core/styles";
import { Router } from "react-router";
import ProjectTheme from "../../assets/styles/theme";
import "./App.css";

import Routes from "../Routes";

const createBrowserHistory = require("history").createBrowserHistory;
const theme = createTheme(ProjectTheme);
const responsiveTheme = responsiveFontSizes(theme);

function App() {
  const history = createBrowserHistory();
  return (
    <>
      <MuiThemeProvider theme={responsiveTheme}>
        <CssBaseline />
        <Router history={history}>
          <Routes />
        </Router>
      </MuiThemeProvider>
    </>
  );
}

export default App;
